module.exports = __webpack_public_path__ + "static/media/pin.9776935c.png";